// src/context/AppContext.js
import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [knowledgeBases, setKnowledgeBases] = useState([
    { 
      id: 1, 
      name: 'Default Knowledge Base', 
      lastUpdated: new Date().toLocaleString(),
      size: '2.4MB',
      status: 'Ready',
      type: 'PDF',
      files: []
    }
  ]);

  const [chats, setChats] = useState([]);

  const addKnowledgeBase = (newKb) => {
    setKnowledgeBases([...knowledgeBases, newKb]);
  };

  const deleteKnowledgeBase = (id) => {
    setKnowledgeBases(knowledgeBases.filter(kb => kb.id !== id));
  };

  const createChat = (newChat) => {
    setChats([...chats, newChat]);
  };

  return (
    <AppContext.Provider value={{ 
      knowledgeBases, 
      addKnowledgeBase,
      deleteKnowledgeBase,
      chats, 
      createChat 
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}